import {
  utils,
} from '@ama-sdk/core';
import {
  AcknowledgeOrderEligibility,
  CancelAndRefundEligibility,
  FlightChangeEligibility,
  FlightReaccommodationEligibility,
  OrderCancelEligibility,
} from '@dapi/sdk';
import {
  createOrderEligibilities,
  MockOrderEligibilities,
  RecursivePartial,
} from '@dapi/sdk/spec';
import {
  boundId1,
  boundId2,
} from './bound';
import {
  arnEwrFlightItem,
  cphOslFlightItem,
} from './flights';
import {
  nonEligibilityReasonCode1,
  nonEligibilityReasonCode201,
  nonEligibilityReasonCode222,
  nonEligibilityReasonCode23,
  nonEligibilityReasonCode24,
  nonEligibilityReasonCode3,
  nonEligibilityReasonCode39408,
  nonEligibilityReasonCode50006,
  nonEligibilityReasonCode6,
  nonEligibilityReasonCode8,
} from './non-eligibility-reasons';

export const start = new utils.DateTime('2024-02-18T23:59:59.000Z');
export const end = new utils.DateTime('2024-03-26T00:00:00.000Z');

export const acknowledgeMock: AcknowledgeOrderEligibility[] = [
  {
    airBoundId: '1',
    disruption: {
      isEligible: true
    },
    waitlistConfirmation: {
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode39408]
    },
    seats: {
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode39408]
    }
  },
  {
    airBoundId: '2',
    disruption: {
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode39408]
    },
    waitlistConfirmation: {
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode39408]
    },
    seats: {
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode39408]
    }
  }
];

export const cancelMock: OrderCancelEligibility = {
  isEligible: false
};

export const cancelAndRefundMock: CancelAndRefundEligibility = {
  isEligible: true
};

export const cancelAndRefundWithNonEligibilityReasonsMock: CancelAndRefundEligibility = {
  isEligible: false,
  nonEligibilityReasons: [nonEligibilityReasonCode6]
};

export const changeMock: FlightChangeEligibility[] = [
  {
    airBoundId: '1',
    flightIds: ['ST1', 'ST4'],
    isEligible: false,
    nonEligibilityReasons: [nonEligibilityReasonCode1],
    nonEligibilityReason: 'flightChangeNotActivated',
    isPenaltyApplied: false
  },
  {
    airBoundId: '2',
    flightIds: ['ST1', 'ST2'],
    isEligible: false,
    nonEligibilityReasons: [nonEligibilityReasonCode1],
    nonEligibilityReason: 'flightChangeNotActivated',
    isPenaltyApplied: false
  },
  {
    airBoundId: '3',
    flightIds: ['ST3'],
    isEligible: false,
    nonEligibilityReasons: [nonEligibilityReasonCode1],
    nonEligibilityReason: 'flightChangeNotActivated',
    isPenaltyApplied: false
  }
];

export const flightReaccommodationMock: FlightReaccommodationEligibility = {
  acknowledge: [{
    airBoundId: '1',
    isEligible: true
  }],
  change: [{
    airBoundId: '1',
    isEligible: true
  }]
};

export const unOneWayOrderEligibilities: MockOrderEligibilities = createOrderEligibilities({
  template: {
    acknowledge: [{
      airBoundId: boundId1,
      disruption: {
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode201, nonEligibilityReasonCode222]
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode39408]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode39408]
      }
    }],
    cancel: cancelMock,
    cancelAndRefund: cancelAndRefundWithNonEligibilityReasonsMock,
    change: [{
      airBoundId: boundId1,
      flightIds: [cphOslFlightItem.id],
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode8],
      nonEligibilityReason: 'discrepancyInOrder'
    }],
    flightReaccommodation: {
      acknowledge: [{
        airBoundId: boundId1,
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode201, nonEligibilityReasonCode222]
      }],
      change: [{
        airBoundId: boundId1,
        isEligible: true
      }]
    },
    seatChange: [{
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode23]
    }],
    serviceChange: [{
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode24]
    }]
  }
});

export const milesRefundOrderEligibilities: MockOrderEligibilities = createOrderEligibilities({
  template: {
    acknowledge: [{
      airBoundId: boundId1,
      disruption: {
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode50006]
      },
      waitlistConfirmation: {
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode39408]
      },
      seats: {
        isEligible: false,
        nonEligibilityReasons: [nonEligibilityReasonCode39408]
      }
    }],
    cancel: cancelMock,
    cancelAndRefund: cancelAndRefundMock,
    change: [{
      airBoundId: boundId1,
      flightIds: [arnEwrFlightItem.id],
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode1],
      nonEligibilityReason: 'flightChangeNotActivated'
    }],
    seatChange: [{
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode23]
    }],
    serviceChange: [{
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode24]
    }]
  }
});

export const cancelAndRefundOrderEligibilities: MockOrderEligibilities = {
  ...unOneWayOrderEligibilities,
  acknowledge: [{
    ...unOneWayOrderEligibilities.acknowledge![0],
    disruption: {
      isEligible: true
    }
  }],
  cancelAndRefund: cancelAndRefundMock,
  change: unOneWayOrderEligibilities.change,
  flightReaccommodation: {
    acknowledge: [{
      airBoundId: boundId1,
      isEligible: true
    }],
    change: [{
      airBoundId: boundId1,
      isEligible: true,
      conditions: [{
        departureDateTime: {
          start,
          end
        }
      }]
    }]
  }
};

const orderEligibilitiesForMultiBoundDisruptionTemplate: RecursivePartial<MockOrderEligibilities> = {
  change: [
    {
      flightIds: ['ST1'],
      isEligible: false,
      nonEligibilityReason: 'flightChangeNotActivated',
      isPenaltyApplied: false
    },
    {
      flightIds: ['ST3'],
      isEligible: false,
      nonEligibilityReason: 'flightChangeNotActivated',
      isPenaltyApplied: false
    },
    {
      flightIds: ['ST2'],
      isEligible: false,
      nonEligibilityReason: 'flightChangeNotActivated',
      isPenaltyApplied: false
    },
    {
      flightIds: ['ST4'],
      isEligible: false,
      nonEligibilityReason: 'flightChangeNotActivated',
      isPenaltyApplied: false
    }
  ],
  cancel: cancelMock,
  flightReaccommodation: {
    acknowledge: [
      {
        airBoundId: boundId1,
        isEligible: true
      },
      {
        airBoundId: boundId2,
        isEligible: false
      }
    ],
    change: [
      {
        airBoundId: boundId1,
        isEligible: true
      },
      {
        airBoundId: boundId2,
        isEligible: true
      }
    ]
  }
};

export const orderEligibilitiesForMultiBoundDisruption = createOrderEligibilities({
  template: orderEligibilitiesForMultiBoundDisruptionTemplate
});

export const orderEligibilitiesForTwoBoundDisruption = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ]
    }
  }
});

/**
 * Order eligibilities for two bounds when both bounds are disrupted and not eligible for change
 */
export const orderEligibilitiesForTwoBoundDisruptionNotEligibleForChange = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForTwoBoundDisruption,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ]
    }
  }
});

/**
 * Order eligibilities for two bounds when first bound is acknowledged and second bound is disrupted and not eligible for change
 */
export const orderEligibilitiesForTwoBoundDisruptionOneBoundAcknowledgedNotEligibleForChange = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForTwoBoundDisruption,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ]
    }
  }
});

/** TODO: Order eligibilities will be fixed with DRX-58484 */
/**
 * Order eligibilities acknowledging both bounds
 */
export const acknowledegedOrderEligibilitiesForTwoBoundDisrupted = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ]
    }
  }
});

/**
 * Order eligibilities for when first bound is acknowledged and second bound is disrupted
 */
export const orderEligibilitiesForTwoBoundsWhenFirstIsAcknowledged = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ]
    }
  }
});

/**
 * Order eligibilities when single bound is disrupted
 */
export const orderEligibilitiesSingleBoundIsDisrupted = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        }
      ]
    }
  }
});

/**
 * Order eligibilities when both bounds are acknowledged
 */
export const orderEligibilitiesForBothBoundsAcknowledged = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ]
    }
  }
});

/**
 * Order eligibilities when single bounds is acknowledged
 */
export const orderEligibilitiesForSingleBoundsAcknowledged = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false
        }
      ],
      change: [
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ]
    }
  }
});

/**
 * Order eligibilities when single bounds is acknowledged and change allowed
 */
export const orderEligibilitiesForSingleBoundsAcknowledgedChangeAllowed = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForSingleBoundsAcknowledged,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ]
    }
  }
});

/**
 * Order eligibilities when single bounds is acknowledged and change allowed
 */
export const orderEligibilitiesForSingleBoundsAcknowledgedChangeAllowedForObFee = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForSingleBoundsAcknowledged,
    change: [
      {
        flightIds: ['ST3'],
        isEligible: false,
        nonEligibilityReason: 'flightChangeNotActivated',
        isPenaltyApplied: false
      },
      {
        flightIds: ['ST1'],
        isEligible: false,
        nonEligibilityReason: 'flightChangeNotActivated',
        isPenaltyApplied: false
      },
      {
        flightIds: ['ST2'],
        isEligible: false,
        nonEligibilityReason: 'flightChangeNotActivated',
        isPenaltyApplied: false
      }
    ],
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ]
    }
  }
});

/**
 * Order eligibilities for one-way when the bound is schedule changed
 */
export const orderEligibilitiesForBoundWithScheduleChange = createOrderEligibilities({
  template: {
    ...unOneWayOrderEligibilities,
    acknowledge: [{
      ...unOneWayOrderEligibilities.acknowledge![0],
      disruption: {
        isEligible: true
      }
    }],
    change: [{
      airBoundId: boundId1,
      flightIds: [cphOslFlightItem.id],
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode1],
      nonEligibilityReason: 'flightChangeNotActivated'
    }],
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ]
    }
  }
});

/**
 * Order eligibilities for one-way when the bound is disrupted and eligible for involuntary type refund method
 */
export const orderEligibilitiesForBoundWithInvolutaryRefundEligibleUsingAmop = createOrderEligibilities({
  template: {
    ...unOneWayOrderEligibilities,
    acknowledge: [{
      ...unOneWayOrderEligibilities.acknowledge![0],
      disruption: {
        isEligible: true
      }
    }],
    cancelAndRefund: cancelAndRefundMock,
    change: [{
      airBoundId: boundId1,
      flightIds: [cphOslFlightItem.id],
      isEligible: false,
      nonEligibilityReasons: [nonEligibilityReasonCode1],
      nonEligibilityReason: 'flightChangeNotActivated'
    }],
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ]
    }
  }
});

/**
 * Order eligibilities for round-trip where one bound is schedule changed
 */
export const orderEligibilitiesForRoundTripOneBoundWithScheduleChange = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        },
        {
          airBoundId: boundId2,
          isEligible: false
        }
      ]
    }
  }
});

/**
 * Order eligibilities for round-trip where both bounds are schedule changed
 */
export const orderEligibilitiesForRoundTripBothBoundWithScheduleChange = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ]
    }
  }
});

/**
 * Order eligibilities for round-trip where one of the bound is disrupted
 */
export const orderEligibilitiesForRoundTripOneBoundDisrupted = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    cancel: cancelMock,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: false,
          nonEligibilityReasons: [nonEligibilityReasonCode3]
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: false
        }
      ]
    }
  }
});

export const orderEligibilitiesForSisterCityTwoBounds = createOrderEligibilities({
  template: {
    ...orderEligibilitiesForMultiBoundDisruptionTemplate,
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        },
        {
          airBoundId: boundId2,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true,
          conditions: [
            {
              originLocationCodes: [
                'NCE',
                'MRS'
              ],
              departureDateTime: {
                start: new utils.DateTime('2024-11-30T00:00:00.000+01:00'),
                end: new utils.DateTime('2024-12-02T23:59:59.000+01:00')
              }
            }
          ]
        },
        {
          airBoundId: boundId2,
          isEligible: true,
          conditions: [
            {
              destinationLocationCodes: [
                'NCE',
                'MRS'
              ],
              departureDateTime: {
                start: new utils.DateTime('2024-12-09T00:00:00.000+01:00'),
                end: new utils.DateTime('2024-12-11T23:59:59.000+01:00')
              }
            }
          ]
        }
      ]
    }
  }
});

export const orderEligibilitiesForSingleBoundSisterCity = createOrderEligibilities({
  template: {
    ...unOneWayOrderEligibilities,
    acknowledge: [{
      ...unOneWayOrderEligibilities.acknowledge![0],
      disruption: {
        isEligible: true
      }
    }],
    flightReaccommodation: {
      acknowledge: [
        {
          airBoundId: boundId1,
          isEligible: true
        }
      ],
      change: [
        {
          airBoundId: boundId1,
          isEligible: true,
          conditions: [{
            originLocationCodes: [
              'NCE',
              'MRS'
            ],
            departureDateTime: {
              start: new utils.DateTime('2024-11-30T00:00:00.000+01:00'),
              end: new utils.DateTime('2024-12-02T23:59:59.000+01:00')
            }
          }]
        }
      ]
    }
  }
});
